<app-review-detail-card
  [title]="view().titleI18nKey | translate"
  editHref="/service"
  testId="review-induction"
  [showEdit]="showEdit()"
  (editRequested)="editRequested.emit($event)"
>
  @if (view().method === 'drop-off') {
    <puro-typography component="p" variant="body2" class="review-induction-summary__drop-off">
      <span>{{ 'createShipment.reviewAndPay.induction.dropOffBefore' | translate }}</span>
      <a
        class="review-induction-summary__location-link"
        [href]="locatorUrl()"
        target="_blank"
        rel="noopener noreferrer"
        [attr.aria-label]="'createShipment.reviewAndPay.induction.dropOffLinkAria' | translate"
      >
        {{ 'createShipment.reviewAndPay.induction.dropOffEmphasis' | translate }}
      </a>
      <span>{{ 'createShipment.reviewAndPay.induction.dropOffAfter' | translate }}</span>
    </puro-typography>
  } @else if (view().method === 'pickup') {
    <div class="review-induction-summary__rows">
      @if (view().pickupConfirmationId) {
        <div class="review-induction-summary__row">
          <puro-typography component="span" variant="body2" class="review-induction-summary__label">
            {{ 'createShipment.reviewAndPay.induction.pickupConfirmationId' | translate }}
          </puro-typography>
          <puro-typography component="span" variant="body2">{{
            view().pickupConfirmationId
          }}</puro-typography>
        </div>
      }
      @if (view().pickupDateLabel) {
        <div class="review-induction-summary__row">
          <puro-typography component="span" variant="body2" class="review-induction-summary__label">
            {{ 'createShipment.reviewAndPay.induction.pickupDate' | translate }}
          </puro-typography>
          <puro-typography component="span" variant="body2">{{
            view().pickupDateLabel
          }}</puro-typography>
        </div>
      }
      @if (view().pickupTimeLabel) {
        <div class="review-induction-summary__row">
          <puro-typography component="span" variant="body2" class="review-induction-summary__label">
            {{ 'createShipment.reviewAndPay.induction.pickupTime' | translate }}
          </puro-typography>
          <puro-typography component="span" variant="body2">{{
            view().pickupTimeLabel
          }}</puro-typography>
        </div>
      }
      @if (view().locationCode) {
        <div class="review-induction-summary__row">
          <puro-typography component="span" variant="body2" class="review-induction-summary__label">
            {{ 'createShipment.reviewAndPay.induction.location' | translate }}
          </puro-typography>
          <puro-typography component="span" variant="body2">
            @if (view().locationLabel; as locationLabel) {
              {{ locationLabel }}
            } @else if (view().locationI18nKey; as locationKey) {
              {{ locationKey | translate }}
            } @else {
              {{ view().locationCode }}
            }
          </puro-typography>
        </div>
      }
      @if (view().courierInstructions) {
        <div class="review-induction-summary__row">
          <puro-typography component="span" variant="body2" class="review-induction-summary__label">
            {{ 'createShipment.reviewAndPay.induction.pickupInstructions' | translate }}
          </puro-typography>
          <puro-typography component="span" variant="body2">{{
            view().courierInstructions
          }}</puro-typography>
        </div>
      }
    </div>
  } @else {
    <puro-typography component="p" variant="body2">
      {{ 'createShipment.reviewAndPay.induction.labelOnlyBody' | translate }}
    </puro-typography>
  }
</app-review-detail-card>
